;(function () {
  var cfg = window.__YMT
  if (!cfg || !cfg.trackUrl) return

  var ANON_KEY = 'ymt_anon'
  var anonId = localStorage.getItem(ANON_KEY)
  if (!anonId) {
    var uid = crypto.randomUUID ? crypto.randomUUID()
      : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
        })
    anonId = 'anon-' + uid
    localStorage.setItem(ANON_KEY, anonId)
  }

  function track(type, extra) {
    var body = {
      anon_id:     anonId,
      type:        type,
      payload:     Object.assign(
        { url: location.href, referrer: document.referrer, template: cfg.template },
        extra || {}
      ),
      occurred_at: new Date().toISOString(),
    }
    if (cfg.email)      body.email              = cfg.email
    if (cfg.customerId) body.shopify_customer_id = String(cfg.customerId)
    fetch(cfg.trackUrl, {
      method:    'POST',
      headers:   { 'Content-Type': 'application/json' },
      body:      JSON.stringify(body),
      keepalive: true,
    }).catch(function () {})
  }

  track('page_view')
  if (cfg.product) track('product_view', cfg.product)
  if (location.pathname.indexOf('/checkout') === 0) track('checkout_started')

  document.addEventListener('submit', function (e) {
    var form = e.target
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return
    var variantEl  = form.querySelector('[name="id"]')
    var quantityEl = form.querySelector('[name="quantity"]')
    track('add_to_cart', {
      variant_id: variantEl  ? variantEl.value  : null,
      quantity:   quantityEl ? quantityEl.value : 1,
    })
  }, true)

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('form[action="/account"]')
    if (!form) return
    var inp   = document.createElement('input')
    inp.type  = 'hidden'
    inp.name  = 'customer[note]'
    inp.value = JSON.stringify({ web_anon_id: anonId })
    form.appendChild(inp)
  })
})()